<template>
    <div class="m-edit-order">
        <b-loading v-model="isUpdateOrderLoading"></b-loading>
        <section style="width:90%">
            <b-field
                :message="inputOrderIDmsg"
                :type="!inputOrderIDmsg ? '': 'is-danger'"
            >
                <b-input
                    placeholder="Order ID"
                    type="text"
                    icon="magnify"
                    v-model="orderID"
                    icon-right="close-circle"
                    icon-right-clickable
                    @icon-right-click="clearIconClick"
                    :loading="isQueryOrderLoading"
                >
                </b-input>
                <p class="control">
                    <b-button
                        type="is-primary"
                        label="Search"
                        @click="onQueryOrder"
                    />
                </p>
            </b-field>
            <hr />
            <!-- <div v-if="true"> -->
            <div v-if="showOrderDetail">
                <div class="columns column is-mobile is-vcentered">
                    <div class="px-0 py-0 column">Edit Order Status To: </div>
                    <b-field class="px-0 py-0 column is-three-fifths">
                        <b-radio-button
                            v-for="(toStatus , index) in statusList"
                            :key="index"
                            v-model="selectedStatus"
                            :native-value="toStatus"
                        >
                            {{toStatus}}
                        </b-radio-button>
                    </b-field>
                </div>
                <div class="is-mobile columns column is-mobile is-vcentered is-centered">
                    <b-tag
                        class="px-0 py-0 column"
                        size="is-medium"
                        type="is-warning"
                    >{{ orderDetail.status }}</b-tag>
                    <div class="px-0 py-0 column is-2 has-text-centered">
                        <b-icon
                            pack="fas"
                            icon="fa-solid fa-arrow-right"
                            size="is-meduim"
                        >
                        </b-icon>
                    </div>
                    <b-tag
                        class="px-0 py-0 column"
                        size="is-medium"
                        type="is-primary"
                    >{{selectedStatus}}</b-tag>
                </div>
                <hr />
                <div>
                    <b-taglist>
                        <b-tag type="is-info">#{{ orderDetail.id }}</b-tag>
                        <b-tag type="is-success">RIDER: {{ orderDetail.driverName }}</b-tag>
                    </b-taglist>
                </div>
                <div class="columns is-mobile">
                    <div class="column is-3">
                        <span class="heading">Origin</span>
                        <p class="text-box">{{ orderDetail.origin }}</p>
                    </div>
                    <div class="column is-8">
                        <span class="heading">Destination</span>
                        <p class="text-box">{{ orderDetail.destination }}</p>
                    </div>
                </div>
                <div
                    class="columns is-mobile"
                    style="padding: 12px 0px 0px"
                >
                    <div class="column is-3">
                        <span class="heading">Date</span>
                        <p class>{{ orderDetail.date.date }}</p>
                    </div>
                    <div class="column is-2">
                        <span class="heading">Time</span>
                        <p class>{{ orderDetail.time }}</p>
                    </div>

                    <div class="column is-5">
                        <span class="heading">name</span>
                        <p class>{{ orderDetail.name }}</p>
                    </div>
                    <div class="column is-2">
                        <span class="heading">price</span>
                        <p class>{{ orderDetail.price }}</p>
                    </div>
                </div>

                <hr />
            </div>
            <div v-if="updateOrderSuccess">
                <div class="is-mobile columns column is-mobile is-vcentered">
                    <div class="px-0 py-0 column is-3">Order Status :</div>
                    <b-tag
                        class="px-0 py-0 column is-3"
                        size="is-medium"
                        type="is-primary"
                    >{{selectedStatus}}</b-tag>
                </div>
                <div>
                    <b-taglist>
                        <b-tag type="is-info">#{{ orderDetail.id }}</b-tag>
                        <b-tag type="is-success">RIDER: {{ orderDetail.driverName }}</b-tag>
                    </b-taglist>
                </div>
                <div class="columns is-mobile">
                    <div class="column is-3">
                        <span class="heading">Origin</span>
                        <p class="text-box">{{ orderDetail.origin }}</p>
                    </div>
                    <div class="column is-8">
                        <span class="heading">Destination</span>
                        <p class="text-box">{{ orderDetail.destination }}</p>
                    </div>
                </div>
                <div
                    class="columns is-mobile"
                    style="padding: 12px 0px 0px"
                >
                    <div class="column is-3">
                        <span class="heading">Date</span>
                        <p class>{{ orderDetail.date.date }}</p>
                    </div>
                    <div class="column is-2">
                        <span class="heading">Time</span>
                        <p class>{{ orderDetail.time }}</p>
                    </div>

                    <div class="column is-5">
                        <span class="heading">name</span>
                        <p class>{{ orderDetail.name }}</p>
                    </div>
                    <div class="column is-2">
                        <span class="heading">price</span>
                        <p class>{{ orderDetail.price }}</p>
                    </div>
                </div>

                <hr />
            </div>
            <b-button
                :disabled="!isEditOrderActive"
                icon-pack="fas"
                icon-left="check"
                label="Confirm"
                type="is-success"
                @click="onConfirmEditOrder"
            />

        </section>
    </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "ManualEditOrderStatus",
  data() {
    return {
      orderID: "",
      isEditOrderActive: false,
      inputOrderIDmsg: "Enter Order ID",
      showOrderDetail: false,
      statusList: ["PROGRESS", "SUCCESS"],
      orderDetail: {},
      isQueryOrderLoading: false,
      isUpdateOrderLoading: false,
      selectedStatus: null,
      updateOrderSuccess: false,
    };
  },
  watch: {
    selectedStatus: {
      handler(val) {
        if (val) {
          this.isEditOrderActive = true;
        } else {
          this.isEditOrderActive = false;
        }
      },
    },
  },
  computed: {
    position() {
      return {
        origin: this.orderDetail.origin,
        destination: this.orderDetail.destination,
        id: this.orderDetail.id,
        active: this.showOrderDetail,
        driver: null,
      };
    },
  },
  methods: {
    async onConfirmEditOrder() {
      if (this.selectedStatus === this.orderDetail.status) {
        this.$buefy.toast.open({
          duration: 2000,
          message: `<i class="fas fa-exclamation-triangle"></i> Order มีสถานะนี้อยู่แล้ว`,
          position: "is-bottom",
          type: "is-warning",
        });
      } else {
        this.isUpdateOrderLoading = true;
        const confirmOrderStatus = await this.$store.dispatch(
          "orders/getSingleOrder",
          this.orderID
        );
        if (this.orderDetail.status === confirmOrderStatus.status) {
          const date = dayjs().format("YYYY-MM-DD");
          const orderDateID = await this.$store.dispatch("orders/getOrderDateId", {
            date: date,
            nStatus: this.selectedStatus,
          });
          console.log("date, dateID >>>", date, orderDateID);
          try {
            const editOrderStatusResult = await this.$store.dispatch("orders/updateOrderInfo", {
              id: this.orderID,
              status: this.selectedStatus,
              orderDateId: orderDateID,
            });
            console.log("editOrderStatus >>>", editOrderStatusResult);
            this.$buefy.toast.open({
              duration: 2000,
              message: `<i class="fas fa-solid fa-check"></i> แก้ไข Order สำเร็จ`,
              position: "is-bottom",
              type: "is-success",
            });
            this.showOrderDetail = false;
            this.updateOrderSuccess = true;
          } catch (e) {
            console.log("manual edit order error >>>", e);
          }
        }
        this.isUpdateOrderLoading = false;
      }
    },
    async onQueryOrder() {
      this.updateOrderSuccess = false;
      this.selectedStatus = null;
      if (this.orderID) {
        console.log("order ID >>>", this.orderID);
        this.isQueryOrderLoading = true;
        this.orderDetail = await this.$store.dispatch("orders/getSingleOrder", this.orderID);
        if (this.orderDetail) {
          this.inputOrderIDmsg = null;
          this.showOrderDetail = true;
        } else {
          this.$buefy.toast.open({
            duration: 2000,
            message: `<i class="fas fa-exclamation-triangle"></i> ไม่พบ Order`,
            position: "is-bottom",
            type: "is-warning",
          });
        }
        this.isQueryOrderLoading = false;
      } else {
        console.log("Please Enter Order ID");
        this.inputOrderIDmsg = "Please Enter Order ID";
        this.showOrderDetail = false;
        this.isEditOrderActive = false;
        this.updateOrderSuccess = false;
      }
    },
    clearIconClick() {
      // this.ShowDirection(this.position);
      this.showOrderDetail = false;
      this.isEditOrderActive = false;
      this.updateOrderSuccess = false;
      this.orderDetail = {};
      this.orderID = null;
      this.selectedStatus = null;
      console.log("clear");
    },
    ShowDirection(position) {
      position;
      const EventBus = this.$root;
      EventBus.$emit("ShowDirection", position, "position");
    },
  },
};
</script>

<style scoped>
.m-edit-order {
  margin-top: 10px;
  padding: 10px;
  background-color: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  /* padding: 10px; */
}
</style>
